import { IGroup } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export type GenerateJoinCodePayload = {
  id: number;
};

export const GenerateJoinCode = async (params: GenerateJoinCodePayload): Promise<IGroup> =>
  provider.Request("/group/join-code", params);
